import { createFileRoute, Link } from "@tanstack/react-router";
import { Mail } from "lucide-react";

import { BrandLogo } from "@/components/BrandLogo";
import { ThemeToggle } from "@/components/ThemeToggle";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";

export const Route = createFileRoute("/signup/confirm")({
  head: () => ({
    meta: [
      { title: "確認メール送信 - KAGEM" },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
  component: SignupConfirmPage,
});

function SignupConfirmPage() {
  const email = typeof window !== "undefined"
    ? new URLSearchParams(window.location.search).get("email")
    : null;

  return (
    <main className="bg-gradient-hero relative flex min-h-screen w-full items-center justify-center overflow-hidden px-4 py-10 sm:px-6">
      <div className="absolute right-4 top-4 sm:right-6 sm:top-6">
        <ThemeToggle />
      </div>

      <div className="w-full max-w-md">
        <div className="mb-6 flex justify-center">
          <Link to="/">
            <BrandLogo size="md" />
          </Link>
        </div>

        <Card className="border-border/60 shadow-2xl shadow-brand-primary/10 backdrop-blur-md">
          <CardHeader className="text-center">
            <div className="mx-auto mb-3 flex h-14 w-14 items-center justify-center rounded-full bg-gradient-brand text-white">
              <Mail className="h-6 w-6" aria-hidden="true" />
            </div>
            <CardTitle className="text-xl">確認メールを送信しました</CardTitle>
            <CardDescription className="text-sm">
              {email ? <><span className="font-medium text-foreground">{email}</span> 宛に</> : "ご登録のメールアドレス宛に"}
              確認リンクをお送りしました。
            </CardDescription>
          </CardHeader>
          <CardContent className="space-y-4 text-sm text-muted-foreground">
            <p>
              メール内のリンクをクリックして、登録を完了してください。
            </p>
            <p>
              メールが届かない場合は、迷惑メールフォルダもご確認ください。
            </p>
            <div className="pt-2 text-center">
              <Link to="/signup" className="text-primary underline-offset-4 hover:underline">
                登録ページに戻る
              </Link>
            </div>
          </CardContent>
        </Card>
      </div>
    </main>
  );
}
